module.exports = __webpack_public_path__ + "img/icon_liked.12d69306.svg";